import { createAuthClient } from "better-auth/react";
import { env } from "./env";

// /auth/* is mounted on the Worker (no /api/ prefix); BA client defaults
// to /api/auth — pin basePath to /auth so calls land on the right route.
export const auth = createAuthClient({
  baseURL: `${env.apiUrl}/auth`,
  fetchOptions: {
    // credentials: "include" so the __Secure-better-auth.session_token cookie
    // travels on every cross-origin call to api-staging.
    credentials: "include",
  },
});

export const { useSession, signIn, signUp, signOut } = auth;
